module.exports = __webpack_public_path__ + "img/logo.252579b5.png";